import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {ReminderPageBO, ReminderPageVO, useExportReminder, useQueryReminderPage} from "@/service/monitor.s";
import {exportFile, formatTime, stringAvatar} from "@/helper/method";
import {Avatar} from "@mui/material";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import {ViewMonitor} from "@/pages/Patent/ViewMonitor";
import {useGetSearchParam} from "@/store/dataGrid.c";
import Chip from "@mui/material/Chip";

const code = "reminder"

export const ReminderListPage = () => {
    const {
        mutate: reminderPageMutate,
        data: reminderPageData,
        isPending: reminderPagePending,
    } = useQueryReminderPage()
    const searchParam: any = useGetSearchParam(code)
    const {mutateAsync: exportReminderMutate} = useExportReminder()

    const columns: GridColDef<ReminderPageVO>[] = [
        {field: "patentName", headerName: "专利名称", flex: 0.88, valueFormatter: value => value || "待定"},
        {field: "customerName", headerName: "客户名称", flex: 0.5},
        {
            field: "seller",
            headerName: "业务人员",
            flex: 0.36,
            align: "center",
            headerAlign: "center",
            display: 'flex',
            renderCell: ({row}) => <Avatar {...stringAvatar(row.seller)} />
        },
        {field: "applyNo", headerName: "申请号", headerAlign: 'center', align: 'center', flex: 0.5},
        {
            field: "patentStatus",
            headerName: "案件状态",
            flex: 0.5,
        },
        {
            field: "isMonitor",
            headerName: "年费监控",
            headerAlign: "left",
            align: "left",
            flex: 0.45,
            renderCell: ({row}) => {
                if (row.isMonitor == 1) {
                    return <Chip label={'监控中'} color={'success'}/>
                }
                return <Chip label={'未监控'} color={'error'}/>
            }
        },
        {
            field: "applyDate",
            headerName: "申请日期",
            flex: 0.45,
            display: 'flex',
            renderCell: ({row}) => <Typography color={'warning'}>{formatTime("D", row.applyDate)}</Typography>
        },
        {
            field: "feeType",
            headerName: "费用名称",
            flex: 0.5,
            renderCell: ({row}) => {
                const applyDate = dayjs(row.applyDate);
                const currentDate = dayjs();
                const diffYear = currentDate.diff(applyDate, "year");
                return <>第{diffYear + 1}年年费</>;
            }
        },
        {
            field: "createdAt",
            headerName: "提醒时间",
            flex: 0.4,
            renderCell: ({row}) => {
                const status: number = reminderPageData?.data?.extra;
                const applyDate = dayjs(row.applyDate);
                const currentDate = dayjs();
                const diffYear = currentDate.diff(applyDate, "year");
                const applyDates = applyDate.add(diffYear, "year");
                if (status != 3) {
                    applyDates.subtract(1, "month");
                } else {
                    applyDates.subtract(7, "month");
                }
                return formatTime("D", applyDates);
            },
        },
    ];

    const btnCallback = async ({btn, onSearch, keys, rows}: BtnType<ReminderPageVO>) => {
        if (btn.code == "reminder_export") {
            const result = await exportReminderMutate({status: "1", ...searchParam})
            exportFile(result, "年费提醒.xlsx")
        }
    }

    return (
        <ProTable<ReminderPageVO>
            loading={reminderPagePending}
            showSearch={true}
            btnCallback={btnCallback}
            columns={columns}
            renderDrawer={{view: <ViewMonitor/>}}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                }
            }}
            data={reminderPageData?.data}
            onSearch={({status, ...rest}: ReminderPageBO) => {
                reminderPageMutate({...rest, status: status || '1'});
            }}
            code={code}
        />
    );
};
